import { Box, Typography, Button } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

function EmptyCartState({ onBrowseMenu }) {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 6,
        px: 2,
      }}
    >
      {/* Big Icon */}
      <Iconify
        icon={"mdi:food-fork-drink"}
        width={64}
        height={64}
        style={{ color: "#9e9e9e", marginBottom: 16 }}
      />

      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        No Items Selected
      </Typography>

      <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
        Looks like you haven’t added anything yet. Select items from the menu to
        get started.
      </Typography>
    </Box>
  );
}

export default EmptyCartState;
